import { common, keyCloakConstants, user } from "../../constants/apiUrl";
import apiService from "../../helper/api-service";
import KeyCloakService from "../../helper/key-cloack-service";
import { urlBinder } from "../../helper/url-binder";
import { IApiResponse } from "../../models/IAPIResponse";

export default new (class keyCloakApiService {
  public loginUser = async (userName: string, password: string) => {
    try {
      let endPoint = urlBinder(user.LOGIN_USER, [`${userName}`, password]);
      const response = await apiService.post(endPoint);
      return response?.data;
    } catch (error: any) {
      if (error.response) {
        return error.response;
      } else {
        throw error;
      }
    }
  };

  public getUsersBasedOnRole = async (role: string) => {
    try {
      let endPoint = urlBinder(keyCloakConstants.GET_ROLE_USERS, [role])
      const response = await KeyCloakService.get(endPoint);
      return response;
    } catch (error: any) {
      if (error.response) {
        return error.response;
      } else {
        throw error;
      }
    }
  };

});